import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "contact",
	collection: "contact",
	idProperty: "_id",
	section: "interactions",
	readOnly: true,
	labels: {"singleTitle":"Contact","listTitle":"Contacts"},
	emptyItem: {"data":null},
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "message",
			label: "Message",
			formatter: Backoffice.formatters.multiLines(),
			editor: {"type":"text","lines":5},
		},
		{
			name: "email",
			label: "Email",
		},
		{
			name: "phone",
			label: "Phone",
		},
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"site": "Site", "getOwnData": "Get Own Data", "deleteAccount": "Delete Account"}),
			editor: {type: "select", options: [{value: "site", label: "Site"}, {value: "getOwnData", label: "Get Own Data"}, {value: "deleteAccount", label: "Delete Account"}]},
		},
		{
			name: "data",
			label: "Data",
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "name",
			label: "Name",
		},
		{
			name: "email",
			label: "Email",
		},
		{
			name: "phone",
			label: "Phone",
		},
		{
			name: "type",
			label: "Type",
			formatter: Backoffice.formatters.mapping({"site": "Site", "getOwnData": "Get Own Data", "deleteAccount": "Delete Account"}),
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};